module.exports = __webpack_public_path__ + "img/1571239146.253a3c28.jpg";